import { Locale } from "@dealer-center/ddc-core-utils";
import LABELS from "./labels.json";

/*
 * Configuration Principle VI: "the react entry point calls `Locale.setLabelsOnce(LABELS)` once
 * at module load with the imported `labels.json`".
 *
 * At module scope, not inside a component. It previously ran in `Configuration.tsx`'s render
 * body, which made every descendant depend on `Configuration` being mounted as an ancestor —
 * the coupling `MyInfo.tsx` used to carry a comment about. Anything rendered outside that tree
 * resolved raw label keys, because `Locale` sets no `fallbackLng` and `getText` returns the key
 * when it cannot resolve one.
 *
 * `setLabelsOnce` is idempotent, so a consumer that also initializes labels is unaffected.
 */
Locale.setLabelsOnce(LABELS);

export * from "./routes";
